var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeLayout',[_c('Head',[_c('title',[_vm._v("Job-Portal | Warnemünder Bau GmbH")])]),_vm._v(" "),_c('Categories',{attrs:{"categories":_vm.categories}}),_vm._v(" "),_c('Projects'),_vm._v(" "),_c('Team'),_vm._v(" "),_c('CTA')],1)}
var staticRenderFns = []

export { render, staticRenderFns }